var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMedalRank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "medal_3349690"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.90057 14.9463L3.22461 21.4067L7.05407 21.0164L9.48584 24.0002L11.9735 17.9945C9.54407 17.848 7.38227 16.6943 5.90057 14.9463Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0992 14.9463C17.6176 16.6943 15.4557 17.8479 13.0264 17.9945L15.514 24.0002L17.9458 21.0164L21.7752 21.4067L19.0992 14.9463Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5005 5.86621C10.5735 5.86621 9.00586 7.43388 9.00586 9.36082C9.00586 11.2878 10.5736 12.8554 12.5005 12.8554C14.4274 12.8554 15.9951 11.2877 15.9951 9.36077C15.9951 7.43384 14.4274 5.86621 12.5005 5.86621Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4996 2C8.44073 2 5.13867 5.30215 5.13867 9.36102C5.13867 13.4199 8.44082 16.722 12.4997 16.722C16.5586 16.722 19.8607 13.4199 19.8607 9.36102C19.8607 5.30215 16.5585 2 12.4996 2Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMedalRank);
export default __webpack_public_path__ + "static/media/icon-medal-rank.31cdb52656da48b8aa4b11938c50b1bb.svg";
export { ForwardRef as ReactComponent };